<template>
  <div>
    <div style="display:flex;justify-content: space-between">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 30px">
        <el-breadcrumb-item v-for="(item,index) in currentNav">
          <span style="font-size: 15px" >{{ item }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
<!--      <div style="position: relative">-->
<!--        <div style="display:flex;flex-direction: column;align-items: center;position: fixed;right: 50px">-->
<!--          <i v-html="messageIcon"></i>-->
<!--          <div style="font-size: 14px">意见反馈</div>-->
<!--        </div>-->
<!--      </div>-->

    </div>

  </div>

</template>

<script>
import {messageIcon} from "@/utils/iconUtils";

export default {
  name: "HeaderBread",
  data(){
    return{
      currentNavList: [],
      messageIcon:messageIcon
    }
  },
  computed: {

    currentNav() {
      return this.$route.name.split('/')
    }
  },
}
</script>

<style scoped>

</style>
